export enum PlanSignatureUploadErrorsEnum {
  KNM_PLAN_HAS_UNSIGNED_KNM = 'KNM_PLAN_HAS_UNSIGNED_KNM',
  KNM_PLAN_XML_NOT_MATCH_UPLOADED = 'KNM_PLAN_XML_NOT_MATCH_UPLOADED',
}
